import * as Sentry from '@sentry/browser';
export default {

    getPricingSign: function(addon, day_text = '/Day'){
        if(addon && addon.pricing === 'one_time'){
            return '';
        }else if (addon && addon.pricing === 'percent'){
            return '%'
        }else{
            return '/'+day_text;
        }
    },
    // Separating using comma, and also limiting decimal point
    thousandSeparator: function (value, decimal = 2) {
        return this.roundNormal(value, decimal).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    sortRenters: function(renters){
        return renters.slice().sort(function(a, b){
            return (a.full_name > b.full_name) ? 1 : -1;
        });
    },

    roundNormal: function (value, decimal = 2) {
        if (value) {
            var base = 10 ** decimal;
            return (Math.round(parseFloat(value) * base) / base).toFixed(decimal);
        } else {
            return '0.00';
        }
    },

    calc_tax_amount: function (value, percentage) {

        return value * percentage / 100;
    },

    // Formatting date
    greaterDate(date) {
         var today_date = moment();
         date = moment(date);
         var date_status = date.diff(today_date, 'days');
         console.log(date_status);
         return date_status >= 0?true:false;
    },// Formatting date
    formatDate(date, format = 'MM/DD/YYYY') {
        return date ? moment(date).format(format) : '';
    },// Formatting date
    formatDateSub(date, format = 'MM/DD/YYYY',day=1) {
        return date ? moment(date).subtract(day, 'days').format(format) : '';
    },
    formatDateAdd(date, format = 'MM/DD/YYYY',day=1) {
        return date ? moment(date).add(day, 'days').format(format) : '';
    },

    // Formatting time
    formatTime(time, format = 'h:mm A') {
        let date = this.formatDate(moment().format('MM/DD/YYYY'));
        return date && time ? moment(date + ' ' + time).format(format) : '';
    },

    formatDateToTime(date, format = 'h:mm A') {
        return date ? moment(date).format(format) : '';
    },

    formatDateToDateAndTime(date, format = 'MM/DD/YYYY h:mm A') {
        return date ? moment(date).format(format) : '';
    },

    // Capitalize First Letter
    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },

    getDiscountRate(price, discount_percentage) {
        return this.roundNormal((price / 100) * discount_percentage, 6);
    },

    getDiscountedPrice(price, discount_percentage, decimal = 2) {
        return this.roundNormal(price - this.getDiscountRate(price, discount_percentage), decimal);
    },

    getGtranslateLangs(){
        return {
            en: 'English',
            fr: 'French',
            // es: 'Spanish'
        }
    },
    getAmercianStates() {
        return {
            AL: 'Alabama',
            AK: 'Alaska',
            AZ: 'Arizona',
            AR: 'Arkansas',
            CA: 'California',
            CO: 'Colorado',
            CT: 'Connecticut',
            DE: 'Delaware',
            DC: 'District of Columbia',
            FL: 'Florida',
            GA: 'Georgia',
            HI: 'Hawaii',
            ID: 'Idaho',
            IL: 'Illinois',
            IN: 'Indiana',
            IA: 'Iowa',
            KS: 'Kansas',
            KY: 'Kentucky',
            LA: 'Louisiana',
            ME: 'Maine',
            MD: 'Maryland',
            MA: 'Massachusetts',
            MI: 'Michigan',
            MN: 'Minnesota',
            MS: 'Mississippi',
            MO: 'Missouri',
            MT: 'Montana',
            NE: 'Nebraska',
            NV: 'Nevada',
            NH: 'New Hampshire',
            NJ: 'New Jersey',
            NM: 'New Mexico',
            NY: 'New York',
            NC: 'North Carolina',
            ND: 'North Dakota',
            OH: 'Ohio',
            OK: 'Oklahoma',
            OR: 'Oregon',
            PA: 'Pennsylvania',
            RI: 'Rhode Island',
            SC: 'South Carolina',
            SD: 'South Dakota',
            TN: 'Tennessee',
            TX: 'Texas',
            UT: 'Utah',
            VT: 'Vermont',
            VA: 'Virginia',
            WA: 'Washington',
            WV: 'West Virginia',
            WI: 'Wisconsin',
            WY: 'Wyoming'
        };
    },

    getCountries() {
        return [
            {
                name: 'Afghanistan',
                mobileCode: '+93',
            },
            {
                name: 'Åland Islands',
                mobileCode: '+358-18',
            },
            {
                name: 'Albania',
                mobileCode: '+355',
            },
            {
                name: 'Algeria',
                mobileCode: '+213',
            },
            {
                name: 'American Samoa',
                mobileCode: '+1684',
            },
            {
                name: 'Andorra',
                mobileCode: '+376',
            },
            {
                name: 'Angola',
                mobileCode: '+244',
            },
            {
                name: 'Anguilla',
                mobileCode: '+1-264',
            },
            {
                name: 'Antigua and Barbuda',
                mobileCode: '+1-268',
            },
            {
                name: 'Argentina',
                mobileCode: '+54',
            },
            {
                name: 'Armenia',
                mobileCode: '+374',
            },
            {
                name: 'Aruba',
                mobileCode: '+297',
            },
            {
                name: 'Australia',
                mobileCode: '+61',
            },
            {
                name: 'Austria',
                mobileCode: '+43',
            },
            {
                name: 'Azerbaijan',
                mobileCode: '+994',
            },
            {
                name: 'Bahamas, The',
                mobileCode: '+1-242',
            },
            {
                name: 'Bahrain',
                mobileCode: '+973',
            },
            {
                name: 'Bangladesh',
                mobileCode: '+880',
            },
            {
                name: 'Barbados',
                mobileCode: '+1-246',
            },
            {
                name: 'Belarus',
                mobileCode: '+375',
            },
            {
                name: 'Belgium',
                mobileCode: '+32',
            },
            {
                name: 'Belize',
                mobileCode: '+501',
            },
            {
                name: 'Benin',
                mobileCode: '+229',
            },
            {
                name: 'Bermuda',
                mobileCode: '+1441',
            },
            {
                name: 'Bhutan',
                mobileCode: '+975',
            },
            {
                name: 'Bolivarian Republic of Venezuela',
                mobileCode: '+58',
            },
            {
                name: 'Bolivia',
                mobileCode: '+591',
            },
            {
                name: 'Bonaire, Sint Eustatius and Saba',
                mobileCode: '+599',
            },
            {
                name: 'Bosnia and Herzegovina',
                mobileCode: '+387',
            },
            {
                name: 'Botswana',
                mobileCode: '+267',
            },
            {
                name: 'Bouvet Island',
                mobileCode: '+',
            },
            {
                name: 'Brazil',
                mobileCode: '+55',
            },
            {
                name: 'British Indian Ocean Territory',
                mobileCode: '+246',
            },
            {
                name: 'Brunei',
                mobileCode: '+673',
            },
            {
                name: 'Bulgaria',
                mobileCode: '+359',
            },
            {
                name: 'Burkina Faso',
                mobileCode: '+226',
            },
            {
                name: 'Burundi',
                mobileCode: '+257',
            },
            {
                name: 'Cabo Verde',
                mobileCode: '+238',
            },
            {
                name: 'Cambodia',
                mobileCode: '+855',
            },
            {
                name: 'Cameroon',
                mobileCode: '+237',
            },
            {
                name: 'Canada',
                mobileCode: '+1',
            },
            {
                name: 'Cayman Islands',
                mobileCode: '+1345',
            },
            {
                name: 'Central African Republic',
                mobileCode: '+236',
            },
            {
                name: 'Chad',
                mobileCode: '+235',
            },
            {
                name: 'Chile',
                mobileCode: '+56',
            },
            {
                name: 'China',
                mobileCode: '+86',
            },
            {
                name: 'Christmas Island',
                mobileCode: '+61',
            },
            {
                name: 'Cocos (Keeling) Islands',
                mobileCode: '+61',
            },
            {
                name: 'Colombia',
                mobileCode: '+57',
            },
            {
                name: 'Comoros',
                mobileCode: '+269',
            },
            {
                name: 'Congo',
                mobileCode: '+242',
            },
            {
                name: 'Congo (DRC)',
                mobileCode: '+243',
            },
            {
                name: 'Cook Islands',
                mobileCode: '+682',
            },
            {
                name: 'Costa Rica',
                mobileCode: '+506',
            },
            {
                name: "Côte d'Ivoire",
                mobileCode: '+225',
            },
            {
                name: 'Croatia',
                mobileCode: '+385',
            },
            {
                name: 'Cuba',
                mobileCode: '+53',
            },
            {
                name: 'Curaçao',
                mobileCode: '+599',
            },
            {
                name: 'Cyprus',
                mobileCode: '+357',
            },
            {
                name: 'Czech Republic',
                mobileCode: '+420',
            },
            {
                name: 'Democratic Republic of Timor-Leste',
                mobileCode: '+670',
            },
            {
                name: 'Denmark',
                mobileCode: '+45',
            },
            {
                name: 'Djibouti',
                mobileCode: '+253',
            },
            {
                name: 'Dominica',
                mobileCode: '+1767',
            },
            {
                name: 'Dominican Republic',
                mobileCode: '+1-809 and 1-829',
            },
            {
                name: 'Ecuador',
                mobileCode: '+593',
            },
            {
                name: 'Egypt',
                mobileCode: '+20',
            },
            {
                name: 'El Salvador',
                mobileCode: '+503',
            },
            {
                name: 'Equatorial Guinea',
                mobileCode: '+240',
            },
            {
                name: 'Eritrea',
                mobileCode: '+291',
            },
            {
                name: 'Estonia',
                mobileCode: '+372',
            },
            {
                name: 'Ethiopia',
                mobileCode: '+251',
            },
            {
                name: 'Falkland Islands (Islas Malvinas)',
                mobileCode: '+500',
            },
            {
                name: 'Faroe Islands',
                mobileCode: '+298',
            },
            {
                name: 'Fiji Islands',
                mobileCode: '+679',
            },
            {
                name: 'Finland',
                mobileCode: '+358',
            },
            {
                name: 'France',
                mobileCode: '+33',
            },
            {
                name: 'French Guiana',
                mobileCode: '+594',
            },
            {
                name: 'French Polynesia',
                mobileCode: '+689',
            },
            {
                name: 'French Southern and Antarctic Lands',
                mobileCode: '+',
            },
            {
                name: 'Gabon',
                mobileCode: '+241',
            },
            {
                name: 'Gambia, The',
                mobileCode: '+220',
            },
            {
                name: 'Georgia',
                mobileCode: '+995',
            },
            {
                name: 'Germany',
                mobileCode: '+49',
            },
            {
                name: 'Ghana',
                mobileCode: '+233',
            },
            {
                name: 'Gibraltar',
                mobileCode: '+350',
            },
            {
                name: 'Greece',
                mobileCode: '+30',
            },
            {
                name: 'Greenland',
                mobileCode: '+299',
            },
            {
                name: 'Grenada',
                mobileCode: '+1473',
            },
            {
                name: 'Guadeloupe',
                mobileCode: '+590',
            },
            {
                name: 'Guam',
                mobileCode: '+1671',
            },
            {
                name: 'Guatemala',
                mobileCode: '+502',
            },
            {
                name: 'Guernsey',
                mobileCode: '+44-1481',
            },
            {
                name: 'Guinea',
                mobileCode: '+224',
            },
            {
                name: 'Guinea-Bissau',
                mobileCode: '+245',
            },
            {
                name: 'Guyana',
                mobileCode: '+592',
            },
            {
                name: 'Haiti',
                mobileCode: '+509',
            },
            {
                name: 'Honduras',
                mobileCode: '+504',
            },
            {
                name: 'Hong Kong SAR',
                mobileCode: '+852',
            },
            {
                name: 'Hungary',
                mobileCode: '+36',
            },
            {
                name: 'Iceland',
                mobileCode: '+354',
            },
            {
                name: 'India',
                mobileCode: '+91',
            },
            {
                name: 'Indonesia',
                mobileCode: '+62',
            },
            {
                name: 'Iran',
                mobileCode: '+98',
            },
            {
                name: 'Iraq',
                mobileCode: '+964',
            },
            {
                name: 'Ireland',
                mobileCode: '+353',
            },
            {
                name: 'Israel',
                mobileCode: '+972',
            },
            {
                name: 'Italy',
                mobileCode: '+39',
            },
            {
                name: 'Jamaica',
                mobileCode: '+1876',
            },
            {
                name: 'Jan Mayen',
                mobileCode: '+47',
            },
            {
                name: 'Japan',
                mobileCode: '+81',
            },
            {
                name: 'Jordan',
                mobileCode: '+962',
            },
            {
                name: 'Kazakhstan',
                mobileCode: '+7',
            },
            {
                name: 'Kenya',
                mobileCode: '+254',
            },
            {
                name: 'Kiribati',
                mobileCode: '+686',
            },
            {
                name: 'Korea',
                mobileCode: '+82',
            },
            {
                name: 'Kuwait',
                mobileCode: '+965',
            },
            {
                name: 'Kyrgyzstan',
                mobileCode: '+996',
            },
            {
                name: 'Laos',
                mobileCode: '+856',
            },
            {
                name: 'Latvia',
                mobileCode: '+371',
            },
            {
                name: 'Lebanon',
                mobileCode: '+961',
            },
            {
                name: 'Lesotho',
                mobileCode: '+266',
            },
            {
                name: 'Liberia',
                mobileCode: '+231',
            },
            {
                name: 'Libya',
                mobileCode: '+218',
            },
            {
                name: 'Liechtenstein',
                mobileCode: '+423',
            },
            {
                name: 'Lithuania',
                mobileCode: '+370',
            },
            {
                name: 'Luxembourg',
                mobileCode: '+352',
            },
            {
                name: 'Macao SAR',
                mobileCode: '+853',
            },
            {
                name: 'Macedonia, Former Yugoslav Republic of',
                mobileCode: '+389',
            },
            {
                name: 'Madagascar',
                mobileCode: '+261',
            },
            {
                name: 'Malawi',
                mobileCode: '+265',
            },
            {
                name: 'Malaysia',
                mobileCode: '+60',
            },
            {
                name: 'Maldives',
                mobileCode: '+960',
            },
            {
                name: 'Mali',
                mobileCode: '+223',
            },
            {
                name: 'Malta',
                mobileCode: '+356',
            },
            {
                name: 'Man, Isle of',
                mobileCode: '+44-1624',
            },
            {
                name: 'Marshall Islands',
                mobileCode: '+692',
            },
            {
                name: 'Martinique',
                mobileCode: '+596',
            },
            {
                name: 'Mauritania',
                mobileCode: '+222',
            },
            {
                name: 'Mauritius',
                mobileCode: '+230',
            },
            {
                name: 'Mayotte',
                mobileCode: '+262',
            },
            {
                name: 'Mexico',
                mobileCode: '+52',
            },
            {
                name: 'Micronesia',
                mobileCode: '+691',
            },
            {
                name: 'Moldova',
                mobileCode: '+373',
            },
            {
                name: 'Monaco',
                mobileCode: '+377',
            },
            {
                name: 'Mongolia',
                mobileCode: '+976',
            },
            {
                name: 'Montenegro',
                mobileCode: '+382',
            },
            {
                name: 'Montserrat',
                mobileCode: '+1664',
            },
            {
                name: 'Morocco',
                mobileCode: '+212',
            },
            {
                name: 'Mozambique',
                mobileCode: '+258',
            },
            {
                name: 'Myanmar',
                mobileCode: '+95',
            },
            {
                name: 'Namibia',
                mobileCode: '+264',
            },
            {
                name: 'Nauru',
                mobileCode: '+674',
            },
            {
                name: 'Nepal',
                mobileCode: '+977',
            },
            {
                name: 'Netherlands',
                mobileCode: '+31',
            },
            {
                name: 'New Caledonia',
                mobileCode: '+687',
            },
            {
                name: 'New Zealand',
                mobileCode: '+64',
            },
            {
                name: 'Nicaragua',
                mobileCode: '+505',
            },
            {
                name: 'Niger',
                mobileCode: '+227',
            },
            {
                name: 'Nigeria',
                mobileCode: '+234',
            },
            {
                name: 'Niue',
                mobileCode: '+683',
            },
            {
                name: 'Norfolk Island',
                mobileCode: '+672',
            },
            {
                name: 'North Korea',
                mobileCode: '+850',
            },
            {
                name: 'Northern Mariana Islands',
                mobileCode: '+1-670',
            },
            {
                name: 'Norway',
                mobileCode: '+47',
            },
            {
                name: 'Oman',
                mobileCode: '+968',
            },
            {
                name: 'Pakistan',
                mobileCode: '+92',
            },
            {
                name: 'Palau',
                mobileCode: '+680',
            },
            {
                name: 'Palestinian Authority',
                mobileCode: '+970',
            },
            {
                name: 'Panama',
                mobileCode: '+507',
            },
            {
                name: 'Papua New Guinea',
                mobileCode: '+675',
            },
            {
                name: 'Paraguay',
                mobileCode: '+595',
            },
            {
                name: 'Peru',
                mobileCode: '+51',
            },
            {
                name: 'Philippines',
                mobileCode: '+63',
            },
            {
                name: 'Pitcairn Islands',
                mobileCode: '+870',
            },
            {
                name: 'Poland',
                mobileCode: '+48',
            },
            {
                name: 'Portugal',
                mobileCode: '+351',
            },
            {
                name: 'Puerto Rico',
                mobileCode: '+1787',
            },
            {
                name: 'Qatar',
                mobileCode: '+974',
            },
            {
                name: 'Reunion',
                mobileCode: '+262',
            },
            {
                name: 'Romania',
                mobileCode: '+40',
            },
            {
                name: 'Russia',
                mobileCode: '+7',
            },
            {
                name: 'Rwanda',
                mobileCode: '+250',
            },
            {
                name: 'Saint Barthélemy',
                mobileCode: '+590',
            },
            {
                name: 'Saint Helena, Ascension and Tristan da Cunha',
                mobileCode: '+290',
            },
            {
                name: 'Saint Kitts and Nevis',
                mobileCode: '+1869',
            },
            {
                name: 'Saint Lucia',
                mobileCode: '+1758',
            },
            {
                name: 'Saint Martin (French part)',
                mobileCode: '+590',
            },
            {
                name: 'Saint Pierre and Miquelon',
                mobileCode: '+508',
            },
            {
                name: 'Saint Vincent and the Grenadines',
                mobileCode: '+1784',
            },
            {
                name: 'Samoa',
                mobileCode: '+685',
            },
            {
                name: 'San Marino',
                mobileCode: '+378',
            },
            {
                name: 'Saudi Arabia',
                mobileCode: '+966',
            },
            {
                name: 'Senegal',
                mobileCode: '+221',
            },
            {
                name: 'Serbia',
                mobileCode: '+381',
            },
            {
                name: 'Seychelles',
                mobileCode: '+248',
            },
            {
                name: 'Sierra Leone',
                mobileCode: '+232',
            },
            {
                name: 'Singapore',
                mobileCode: '+65',
            },
            {
                name: 'Sint Maarten (Dutch part)',
                mobileCode: '+599',
            },
            {
                name: 'Slovakia',
                mobileCode: '+421',
            },
            {
                name: 'Slovenia',
                mobileCode: '+386',
            },
            {
                name: 'Solomon Islands',
                mobileCode: '+677',
            },
            {
                name: 'Somalia',
                mobileCode: '+252',
            },
            {
                name: 'South Africa',
                mobileCode: '+27',
            },
            {
                name: 'South Sudan',
                mobileCode: '+211',
            },
            {
                name: 'Spain',
                mobileCode: '+34',
            },
            {
                name: 'Sri Lanka',
                mobileCode: '+94',
            },
            {
                name: 'Sudan',
                mobileCode: '+249',
            },
            {
                name: 'Suriname',
                mobileCode: '+597',
            },
            {
                name: 'Svalbard',
                mobileCode: '+47',
            },
            {
                name: 'Swaziland',
                mobileCode: '+268',
            },
            {
                name: 'Sweden',
                mobileCode: '+46',
            },
            {
                name: 'Switzerland',
                mobileCode: '+41',
            },
            {
                name: 'Syria',
                mobileCode: '+963',
            },
            {
                name: 'Taiwan',
                mobileCode: '+886',
            },
            {
                name: 'Tajikistan',
                mobileCode: '+992',
            },
            {
                name: 'Tanzania',
                mobileCode: '+255',
            },
            {
                name: 'Thailand',
                mobileCode: '+66',
            },
            {
                name: 'Togo',
                mobileCode: '+228',
            },
            {
                name: 'Tokelau',
                mobileCode: '+690',
            },
            {
                name: 'Tonga',
                mobileCode: '+676',
            },
            {
                name: 'Trinidad and Tobago',
                mobileCode: '+1-868',
            },
            {
                name: 'Tunisia',
                mobileCode: '+216',
            },
            {
                name: 'Turkey',
                mobileCode: '+90',
            },
            {
                name: 'Turkmenistan',
                mobileCode: '+993',
            },
            {
                name: 'Turks and Caicos Islands',
                mobileCode: '+1649',
            },
            {
                name: 'Tuvalu',
                mobileCode: '+688',
            },
            {
                name: 'U.S. Minor Outlying Islands',
                mobileCode: '+1',
            },
            {
                name: 'Uganda',
                mobileCode: '+256',
            },
            {
                name: 'Ukraine',
                mobileCode: '+380',
            },
            {
                name: 'United Arab Emirates',
                mobileCode: '+971',
            },
            {
                name: 'United Kingdom',
                mobileCode: '+44',
            },
            {
                name: 'United States',
                mobileCode: '+1',
            },
            {
                name: 'Uruguay',
                mobileCode: '+598',
            },
            {
                name: 'Uzbekistan',
                mobileCode: '+998',
            },
            {
                name: 'Vanuatu',
                mobileCode: '+678',
            },
            {
                name: 'Vatican City',
                mobileCode: '+379',
            },
            {
                name: 'Vietnam',
                mobileCode: '+84',
            },
            {
                name: 'Virgin Islands, U.S.',
                mobileCode: '+1340',
            },
            {
                name: 'Virgin Islands, British',
                mobileCode: '+1284',
            },
            {
                name: 'Wallis and Futuna',
                mobileCode: '+681',
            },
            {
                name: 'Yemen',
                mobileCode: '+967',
            },
            {
                name: 'Zambia',
                mobileCode: '+260',
            },
            {
                name: 'Zimbabwe',
                mobileCode: '+263',
            },
        ];

    },

    getAllCountries(){
        return [[ "United States", "us", "1", 0 ], [ "Afghanistan (‫افغانستان‬‎)", "af", "93" ], [ "Albania (Shqipëri)", "al", "355" ], [ "Algeria (‫الجزائر‬‎)", "dz", "213" ], [ "American Samoa", "as", "1", 5, [ "684" ] ], [ "Andorra", "ad", "376" ], [ "Angola", "ao", "244" ], [ "Anguilla", "ai", "1", 6, [ "264" ] ], [ "Antigua and Barbuda", "ag", "1", 7, [ "268" ] ], [ "Argentina", "ar", "54" ], [ "Armenia (Հայաստան)", "am", "374" ], [ "Aruba", "aw", "297" ], [ "Ascension Island", "ac", "247" ], [ "Australia", "au", "61", 0 ], [ "Austria (Österreich)", "at", "43" ], [ "Azerbaijan (Azərbaycan)", "az", "994" ], [ "Bahamas", "bs", "1", 8, [ "242" ] ], [ "Bahrain (‫البحرين‬‎)", "bh", "973" ], [ "Bangladesh (বাংলাদেশ)", "bd", "880" ], [ "Barbados", "bb", "1", 9, [ "246" ] ], [ "Belarus (Беларусь)", "by", "375" ], [ "Belgium (België)", "be", "32" ], [ "Belize", "bz", "501" ], [ "Benin (Bénin)", "bj", "229" ], [ "Bermuda", "bm", "1", 10, [ "441" ] ], [ "Bhutan (འབྲུག)", "bt", "975" ], [ "Bolivia", "bo", "591" ], [ "Bosnia and Herzegovina (Босна и Херцеговина)", "ba", "387" ], [ "Botswana", "bw", "267" ], [ "Brazil (Brasil)", "br", "55" ], [ "British Indian Ocean Territory", "io", "246" ], [ "British Virgin Islands", "vg", "1", 11, [ "284" ] ], [ "Brunei", "bn", "673" ], [ "Bulgaria (България)", "bg", "359" ], [ "Burkina Faso", "bf", "226" ], [ "Burundi (Uburundi)", "bi", "257" ], [ "Cambodia (កម្ពុជា)", "kh", "855" ], [ "Cameroon (Cameroun)", "cm", "237" ], [ "Canada", "ca", "1", 1, [ "204", "226", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905" ] ], [ "Cape Verde (Kabu Verdi)", "cv", "238" ], [ "Caribbean Netherlands", "bq", "599", 1, [ "3", "4", "7" ] ], [ "Cayman Islands", "ky", "1", 12, [ "345" ] ], [ "Central African Republic (République centrafricaine)", "cf", "236" ], [ "Chad (Tchad)", "td", "235" ], [ "Chile", "cl", "56" ], [ "China (中国)", "cn", "86" ], [ "Christmas Island", "cx", "61", 2, [ "89164" ] ], [ "Cocos (Keeling) Islands", "cc", "61", 1, [ "89162" ] ], [ "Colombia", "co", "57" ], [ "Comoros (‫جزر القمر‬‎)", "km", "269" ], [ "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)", "cd", "243" ], [ "Congo (Republic) (Congo-Brazzaville)", "cg", "242" ], [ "Cook Islands", "ck", "682" ], [ "Costa Rica", "cr", "506" ], [ "Côte d’Ivoire", "ci", "225" ], [ "Croatia (Hrvatska)", "hr", "385" ], [ "Cuba", "cu", "53" ], [ "Curaçao", "cw", "599", 0 ], [ "Cyprus (Κύπρος)", "cy", "357" ], [ "Czech Republic (Česká republika)", "cz", "420" ], [ "Denmark (Danmark)", "dk", "45" ], [ "Djibouti", "dj", "253" ], [ "Dominica", "dm", "1", 13, [ "767" ] ], [ "Dominican Republic (República Dominicana)", "do", "1", 2, [ "809", "829", "849" ] ], [ "Ecuador", "ec", "593" ], [ "Egypt (‫مصر‬‎)", "eg", "20" ], [ "El Salvador", "sv", "503" ], [ "Equatorial Guinea (Guinea Ecuatorial)", "gq", "240" ], [ "Eritrea", "er", "291" ], [ "Estonia (Eesti)", "ee", "372" ], [ "Eswatini", "sz", "268" ], [ "Ethiopia", "et", "251" ], [ "Falkland Islands (Islas Malvinas)", "fk", "500" ], [ "Faroe Islands (Føroyar)", "fo", "298" ], [ "Fiji", "fj", "679" ], [ "Finland (Suomi)", "fi", "358", 0 ], [ "France", "fr", "33" ], [ "French Guiana (Guyane française)", "gf", "594" ], [ "French Polynesia (Polynésie française)", "pf", "689" ], [ "Gabon", "ga", "241" ], [ "Gambia", "gm", "220" ], [ "Georgia (საქართველო)", "ge", "995" ], [ "Germany (Deutschland)", "de", "49" ], [ "Ghana (Gaana)", "gh", "233" ], [ "Gibraltar", "gi", "350" ], [ "Greece (Ελλάδα)", "gr", "30" ], [ "Greenland (Kalaallit Nunaat)", "gl", "299" ], [ "Grenada", "gd", "1", 14, [ "473" ] ], [ "Guadeloupe", "gp", "590", 0 ], [ "Guam", "gu", "1", 15, [ "671" ] ], [ "Guatemala", "gt", "502" ], [ "Guernsey", "gg", "44", 1, [ "1481", "7781", "7839", "7911" ] ], [ "Guinea (Guinée)", "gn", "224" ], [ "Guinea-Bissau (Guiné Bissau)", "gw", "245" ], [ "Guyana", "gy", "592" ], [ "Haiti", "ht", "509" ], [ "Honduras", "hn", "504" ], [ "Hong Kong (香港)", "hk", "852" ], [ "Hungary (Magyarország)", "hu", "36" ], [ "Iceland (Ísland)", "is", "354" ], [ "India (भारत)", "in", "91" ], [ "Indonesia", "id", "62" ], [ "Iran (‫ایران‬‎)", "ir", "98" ], [ "Iraq (‫العراق‬‎)", "iq", "964" ], [ "Ireland", "ie", "353" ], [ "Isle of Man", "im", "44", 2, [ "1624", "74576", "7524", "7924", "7624" ] ], [ "Israel (‫ישראל‬‎)", "il", "972" ], [ "Italy (Italia)", "it", "39", 0 ], [ "Jamaica", "jm", "1", 4, [ "876", "658" ] ], [ "Japan (日本)", "jp", "81" ], [ "Jersey", "je", "44", 3, [ "1534", "7509", "7700", "7797", "7829", "7937" ] ], [ "Jordan (‫الأردن‬‎)", "jo", "962" ], [ "Kazakhstan (Казахстан)", "kz", "7", 1, [ "33", "7" ] ], [ "Kenya", "ke", "254" ], [ "Kiribati", "ki", "686" ], [ "Kosovo", "xk", "383" ], [ "Kuwait (‫الكويت‬‎)", "kw", "965" ], [ "Kyrgyzstan (Кыргызстан)", "kg", "996" ], [ "Laos (ລາວ)", "la", "856" ], [ "Latvia (Latvija)", "lv", "371" ], [ "Lebanon (‫لبنان‬‎)", "lb", "961" ], [ "Lesotho", "ls", "266" ], [ "Liberia", "lr", "231" ], [ "Libya (‫ليبيا‬‎)", "ly", "218" ], [ "Liechtenstein", "li", "423" ], [ "Lithuania (Lietuva)", "lt", "370" ], [ "Luxembourg", "lu", "352" ], [ "Macau (澳門)", "mo", "853" ], [ "Macedonia (FYROM) (Македонија)", "mk", "389" ], [ "Madagascar (Madagasikara)", "mg", "261" ], [ "Malawi", "mw", "265" ], [ "Malaysia", "my", "60" ], [ "Maldives", "mv", "960" ], [ "Mali", "ml", "223" ], [ "Malta", "mt", "356" ], [ "Marshall Islands", "mh", "692" ], [ "Martinique", "mq", "596" ], [ "Mauritania (‫موريتانيا‬‎)", "mr", "222" ], [ "Mauritius (Moris)", "mu", "230" ], [ "Mayotte", "yt", "262", 1, [ "269", "639" ] ], [ "Mexico (México)", "mx", "52" ], [ "Micronesia", "fm", "691" ], [ "Moldova (Republica Moldova)", "md", "373" ], [ "Monaco", "mc", "377" ], [ "Mongolia (Монгол)", "mn", "976" ], [ "Montenegro (Crna Gora)", "me", "382" ], [ "Montserrat", "ms", "1", 16, [ "664" ] ], [ "Morocco (‫المغرب‬‎)", "ma", "212", 0 ], [ "Mozambique (Moçambique)", "mz", "258" ], [ "Myanmar (Burma) (မြန်မာ)", "mm", "95" ], [ "Namibia (Namibië)", "na", "264" ], [ "Nauru", "nr", "674" ], [ "Nepal (नेपाल)", "np", "977" ], [ "Netherlands (Nederland)", "nl", "31" ], [ "New Caledonia (Nouvelle-Calédonie)", "nc", "687" ], [ "New Zealand", "nz", "64" ], [ "Nicaragua", "ni", "505" ], [ "Niger (Nijar)", "ne", "227" ], [ "Nigeria", "ng", "234" ], [ "Niue", "nu", "683" ], [ "Norfolk Island", "nf", "672" ], [ "North Korea (조선 민주주의 인민 공화국)", "kp", "850" ], [ "Northern Mariana Islands", "mp", "1", 17, [ "670" ] ], [ "Norway (Norge)", "no", "47", 0 ], [ "Oman (‫عُمان‬‎)", "om", "968" ], [ "Pakistan (‫پاکستان‬‎)", "pk", "92" ], [ "Palau", "pw", "680" ], [ "Palestine (‫فلسطين‬‎)", "ps", "970" ], [ "Panama (Panamá)", "pa", "507" ], [ "Papua New Guinea", "pg", "675" ], [ "Paraguay", "py", "595" ], [ "Peru (Perú)", "pe", "51" ], [ "Philippines", "ph", "63" ], [ "Poland (Polska)", "pl", "48" ], [ "Portugal", "pt", "351" ], [ "Puerto Rico", "pr", "1", 3, [ "787", "939" ] ], [ "Qatar (‫قطر‬‎)", "qa", "974" ], [ "Réunion (La Réunion)", "re", "262", 0 ], [ "Romania (România)", "ro", "40" ], [ "Russia (Россия)", "ru", "7", 0 ], [ "Rwanda", "rw", "250" ], [ "Saint Barthélemy", "bl", "590", 1 ], [ "Saint Helena", "sh", "290" ], [ "Saint Kitts and Nevis", "kn", "1", 18, [ "869" ] ], [ "Saint Lucia", "lc", "1", 19, [ "758" ] ], [ "Saint Martin (Saint-Martin (partie française))", "mf", "590", 2 ], [ "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)", "pm", "508" ], [ "Saint Vincent and the Grenadines", "vc", "1", 20, [ "784" ] ], [ "Samoa", "ws", "685" ], [ "San Marino", "sm", "378" ], [ "São Tomé and Príncipe (São Tomé e Príncipe)", "st", "239" ], [ "Saudi Arabia (‫المملكة العربية السعودية‬‎)", "sa", "966" ], [ "Senegal (Sénégal)", "sn", "221" ], [ "Serbia (Србија)", "rs", "381" ], [ "Seychelles", "sc", "248" ], [ "Sierra Leone", "sl", "232" ], [ "Singapore", "sg", "65" ], [ "Sint Maarten", "sx", "1", 21, [ "721" ] ], [ "Slovakia (Slovensko)", "sk", "421" ], [ "Slovenia (Slovenija)", "si", "386" ], [ "Solomon Islands", "sb", "677" ], [ "Somalia (Soomaaliya)", "so", "252" ], [ "South Africa", "za", "27" ], [ "South Korea (대한민국)", "kr", "82" ], [ "South Sudan (‫جنوب السودان‬‎)", "ss", "211" ], [ "Spain (España)", "es", "34" ], [ "Sri Lanka (ශ්‍රී ලංකාව)", "lk", "94" ], [ "Sudan (‫السودان‬‎)", "sd", "249" ], [ "Suriname", "sr", "597" ], [ "Svalbard and Jan Mayen", "sj", "47", 1, [ "79" ] ], [ "Sweden (Sverige)", "se", "46" ], [ "Switzerland (Schweiz)", "ch", "41" ], [ "Syria (‫سوريا‬‎)", "sy", "963" ], [ "Taiwan (台灣)", "tw", "886" ], [ "Tajikistan", "tj", "992" ], [ "Tanzania", "tz", "255" ], [ "Thailand (ไทย)", "th", "66" ], [ "Timor-Leste", "tl", "670" ], [ "Togo", "tg", "228" ], [ "Tokelau", "tk", "690" ], [ "Tonga", "to", "676" ], [ "Trinidad and Tobago", "tt", "1", 22, [ "868" ] ], [ "Tunisia (‫تونس‬‎)", "tn", "216" ], [ "Turkey (Türkiye)", "tr", "90" ], [ "Turkmenistan", "tm", "993" ], [ "Turks and Caicos Islands", "tc", "1", 23, [ "649" ] ], [ "Tuvalu", "tv", "688" ], [ "U.S. Virgin Islands", "vi", "1", 24, [ "340" ] ], [ "Uganda", "ug", "256" ], [ "Ukraine (Україна)", "ua", "380" ], [ "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)", "ae", "971" ], [ "United Kingdom", "gb", "44", 0 ], [ "Uruguay", "uy", "598" ], [ "Uzbekistan (Oʻzbekiston)", "uz", "998" ], [ "Vanuatu", "vu", "678" ], [ "Vatican City (Città del Vaticano)", "va", "39", 1, [ "06698" ] ], [ "Venezuela", "ve", "58" ], [ "Vietnam (Việt Nam)", "vn", "84" ], [ "Wallis and Futuna (Wallis-et-Futuna)", "wf", "681" ], [ "Western Sahara (‫الصحراء الغربية‬‎)", "eh", "212", 1, [ "5288", "5289" ] ], [ "Yemen (‫اليمن‬‎)", "ye", "967" ], [ "Zambia", "zm", "260" ], [ "Zimbabwe", "zw", "263" ], [ "Åland Islands", "ax", "358", 1, [ "18" ] ] ];
    },

    getDailCode() {
        var allCountries = this.getAllCountries();
        // loop over all of the countries above, restructuring the data to be objects with named keys
        var dailCodes = [];
        for (var i = 0; i < allCountries.length; i++) {
            dailCodes.push('+'+ allCountries[i][2]);
        }
        return dailCodes;
    },

    getCountryByDialCode(dial_code){
        return this.getAllCountries().find(country => country[2] == dial_code)
    },

    strReplace(str, replace_from, replace_to) {
        if (typeof str !== 'string') return ''
        return str.replace(replace_from, replace_to);
    },

    replaceAll(string, search, replace) {
        if (typeof string !== 'string') return ''
        return string.split(search).join(replace);
    },

    ucwords(str) {
        if (typeof str !== 'string') return ''
        return str.charAt(0).toUpperCase() + str.slice(1)
    },

    getIncOrDecPercent(before, now){
        before = parseFloat(before);
        now = parseFloat(now);
        let diff = now - before;
        if (now === 0 && before === 0) {
            return '0%';
        }else if(now === diff) {
            return '100%';
        }else{
            return this.thousandSeparator((diff * 100) / before) +'%';
        }
    },

    getInititals(string) {
        if(string){
            var names = string.split(' '),
                initials = names[0].substring(0, 1).toUpperCase();

            if (names.length > 1) {
                initials += names[names.length - 1].substring(0, 1).toUpperCase();
            }
            return initials;
        }else{
            return 'N/A'
        }

    },


    getDates(startDate, stopDate) {
        var dateArray = [];
        var currentDate = moment(startDate);
        var stopDate = moment(stopDate);
        while (currentDate <= stopDate) {
            dateArray.push(moment(currentDate).format('YYYY-MM-DD'))
            currentDate = moment(currentDate).add(1, 'days');
        }
        return dateArray;
    },

    generateArrayOfYears() {
        var min = new Date().getFullYear();
        var max = min + 9;
        var years = []
        for (var i = min; i <= max; i++) {
            years.push(i);
        }
        return years;
    },
    // Setting bearer token for the api calls
    setAccessToken(user) {
        localStorage.removeItem('getToken');
        localStorage.setItem('getToken', user); // store the token in localstorage
    },// Setting bearer token for the api calls
    setUser(user) {
        localStorage.removeItem('getUser');
        localStorage.setItem('getUser', JSON.stringify(user)); // store the token in localstorage
    },

    getUser() {
        return localStorage.getItem('getUser') && JSON.parse(localStorage.getItem('getUser'));
    },

    initializeGTranslate(settings) {
        // if(settings){
        //     window.gtranslateSettings =settings;
        //     // Replace the existing globe wrapper element with a new one
        //     const wrapper = document.querySelector('.gtranslate_wrapper');
        //     if (wrapper) {
        //         wrapper.innerHTML = '';
        //     }

        //     this.loadScript('https://cdn.gtranslate.net/widgets/latest/globe.js', () => {
        //         console.log('GTranslate script loaded and initialized.');
        //     });
        // }

    },



    loadScript(url, callback) {
        // Check if the script already exists
        const existingScript = Array.from(document.head.getElementsByTagName('script'))
            .find(script => script.src === url);

        if (existingScript) {
            // If the script exists, remove it
            document.head.removeChild(existingScript);
        }

        // Create and append the new script
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.defer = true;

        script.onload = () => {
            if (callback) callback();
        };

        document.head.appendChild(script);
    },

    clearLocalStorage() {
        localStorage.removeItem('cart');
        localStorage.removeItem('store_state');
        localStorage.removeItem('coupon');
        localStorage.removeItem('socialData');
    },

    getFeetInches(with_default_option = false) {
        let options = [''];
        var i;
        for (i = 35; i < 96; ++i) {
            let x = Math.floor(i / 12);
            let y = i % 12;
            options.push(x + "' " + y + "''");

            // if (with_default_option && x == 6 && y == 4) {
            //     options.push('');
            // }
        }
        return options;
    },

    getCMOptions() {
        let options = [''];
        for (let i = 90; i <= 215; ++i) {
            options.push(i);
        }
        return options;
    },

    strShortened(str, val = 100){
        if(str.length > val){
            return str.slice(0, val)+' ..';
        }else{
            return str
        }
    },
    usa_phone_format(phone) {
        let phoneNumber = '+' + phone;
        phoneNumber = phoneNumber.replace(/[^0-9]/g, '');

        if (phoneNumber.length > 10) {
            const countryCode = phoneNumber.slice(0, phoneNumber.length - 10);
            const areaCode = phoneNumber.slice(-10, -7);
            const nextThree = phoneNumber.slice(-7, -4);
            const lastFour = phoneNumber.slice(-4);

            phoneNumber = `+${countryCode}-${areaCode}-${nextThree}-${lastFour}`;
        } else if (phoneNumber.length === 10) {
            const areaCode = phoneNumber.slice(0, 3);
            const nextThree = phoneNumber.slice(3, 6);
            const lastFour = phoneNumber.slice(6);

            phoneNumber = `${areaCode}-${nextThree}-${lastFour}`;
        } else if (phoneNumber.length === 7) {
            const nextThree = phoneNumber.slice(0, 3);
            const lastFour = phoneNumber.slice(3);

            phoneNumber = `${nextThree}-${lastFour}`;
        }

        return phoneNumber;
    },
    //level: user, system, process
    captureSentryEvent(message, level = 'error') {
        try {
            const user = localStorage.getItem('getUser') && JSON.parse(localStorage.getItem('getUser'));

            // Set user context if available
            if (user) {
                Sentry.setUser({
                    id: user.id,  // User ID
                    email: user.email,  // User Email
                });
            }

            // Create a generic event object
            const event = {
                message: message,
                level: level,  // Log level ('error', 'warning', 'info', etc.)
            };

            // Capture event
            Sentry.captureEvent(event);
        } catch (err) {
            console.error('Error in Sentry helper:', err);
        }
    },

    doesFieldExist(commaSeparatedString, searchField) {
    // Split the string into an array, trim whitespace, and check for the search word
        const wordsArray = commaSeparatedString.split(',').map(word => word.trim());
        return wordsArray.includes(searchField);
    }
}
